

var og_elem = document.querySelector('.magazine__og');

if (og_elem) {
  var img = og_elem.dataset.og;
  var title = og_elem.dataset.title;
  if (img) {
    document.querySelector('meta[property="og:image"]').setAttribute("content", img);
  }
  if (title) {
    document.querySelector('meta[property="og:title"]').setAttribute("content", title);
  }
}
